import { GAMES_DOC, GAMES_MAP_KEY, type GameMeta } from '@awwyeah/shared';
import type * as Y from 'yjs';
import { useYDoc, useYMap } from '../../sync';

/** The family-visible `games` registry — every match's metadata, no audience machinery
 * (games are family-visible by design, see `packages/shared/src/modules/games/index.ts`). */
export function useGamesRegistry(): {
  doc: Y.Doc;
  map: Y.Map<GameMeta>;
  games: GameMeta[];
} {
  const doc = useYDoc(GAMES_DOC);
  const { map, entries } = useYMap<GameMeta>(doc, GAMES_MAP_KEY);
  const games = entries.map(([, meta]) => meta);
  return { doc, map, games };
}
